module.exports = __webpack_public_path__ + "img/logo-fountainhead.13781c67.svg";